@if( verse ) {
  <!-- The interlinear display -->
  <mat-card>
    <div class="verse" [ngClass]="verse.language">
      @for( word of verse.words; track word) {
        <app-word-display [word]="word" [verse]="verse"></app-word-display>
      }
    </div> 
  </mat-card>

   @if(verse.phraseGlosses.length > 0) {
    @for( key of phraseGlossKeys; track key) {
      <mat-card>
        <mat-card-header [ngClass]="verse.language">{{verse.textPortion( key.from, key.to)}}</mat-card-header>
        <mat-card-content>
          <app-phrase-gloss-display [glosses]="phraseGlosses.get(key.asString()) || []" [verse]="verse"></app-phrase-gloss-display>
        </mat-card-content>
      </mat-card>
    }
   }

   <div id="addPhraseGloss">
    <button mat-button aria-label="Add phrase gloss" (click)="addPhrasalGloss()">
      Add a phrase gloss...
    </button>
    </div>
  } @else {

  @if( verse === null ) {
    <div class="error">
      <p>No data came from the server. Check your internet connection and try again. If your internet connection is fine, then the problem is on our end.</p>
    </div>
  } @else {
    <div class="spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }
}